import { AddButton } from "../../../utils/Custom/Button";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const QualificationExcel = ({ data = [], searchBy = "Electrical" }) => {
  const exportToExcel = () => {
    const wsData = [];

    if (searchBy === "Electrical") {
      // ----------- Header Rows for Electrical ----------
      wsData.push([
        "Sr.No.",
        "Name",
        "Location",
        "Experience",
        "Basic Qualification",
        ...Array(9).fill(
          "NABCB SCOPE SECTOR 19a\nIEC 60034-2-1 (Motors) / IS STANDARDS"
        ),
        "QMS Auditor",
        "Remarks",
      ]);

      wsData.push([
        "",
        "",
        "",
        "",
        "",
        ...Array(9).fill("Electrical Equipment"),
        "",
        "",
      ]);

      wsData.push([
        "",
        "",
        "",
        "Years",
        "Basic Qualification",
        "Motors",
        "Control Panel",
        "Switch Gears",
        "Generators",
        "Transformers",
        "Cables & Wires",
        "Capacitors",
        "Battery Chargers / Inverters / UPS",
        "Instruments",
        "QMS Auditor",
        "Remarks",
      ]);

      // ----------- Data Rows for Electrical ----------
      data.forEach((row, i) => {
        wsData.push([
          i + 1,
          row.emp_name,
          row.location,
          row.experience,
          row.qualification,
          row.motors,
          row.controlPanel,
          row.switchGears,
          row.generators,
          row.transformers,
          row.cablesWires,
          row.capacitors,
          row.chargersInvertersUPS,
          row.instruments,
          row.systemAuditor,
          row.remarks,
        ]);
      });
    } else {
      // ----------- Header Rows for Mechanical ----------
      wsData.push([
        "Sr.No.",
        "Name",
        "Location",
        "Experience",
        "Basic Quali.",
        ...Array(6).fill("NDE"),
        "BGAS / NACE",
        "API",
        "Welding",
        ...Array(9).fill(
          "NABCB SCOPE SECTOR 17a\n(ASME: Sec. II Part A, Sec V)\nASTM (as applicable)\nIS STANDARDS (IS4985, IS4984, IS 16647)"
        ),
        ...Array(8).fill(
          "NABCB SCOPE SCOPE 17b\nASME: Sec. VIII Div 1 & 2, Sec V, Sec. IX, Sec II part B & C.,\nASME B31.3, API 1104 (Piping), ASTM (as applicable)\nIS STANDARDS"
        ),
        ...Array(4).fill(
          "NABCB SCOPE SECTOR 18\nPump - API: 610, 674, 675. Valves - API: 598, 608, 6A & 6D\nCompressors – API: 617, 618 & 619 Applicable ASME Standards IS 15856 (Valves)"
        ),
        "System Auditor",
        "Remarks",
      ]);

      wsData.push([
        "",
        "",
        "",
        "",
        "",
        "LPT",
        "RT",
        "UT",
        "MPT",
        "VT",
        "FET",
        "",
        "",
        "",
        ...Array(9).fill("Basic Metals"),
        ...Array(8).fill("FABRICATED METAL PRODUCTS"),
        ...Array(4).fill("MACHINERY & EQUIPMENT"),
        "",
        "",
      ]);

      wsData.push([
        "",
        "",
        "",
        "Years",
        "Basic Quali.",
        "LPT",
        "RT",
        "UT",
        "MPT",
        "VT",
        "FET",
        "BGAS / NACE",
        "API",
        "Welding",
        "Plates",
        "Pipes",
        "Line Pipe",
        "Flanges",
        "Fittings",
        "Fasteners",
        "Forging",
        "Casting",
        "Rolling",
        "Pressure Vessels",
        "Heat Exchangers",
        "Columns",
        "Reactors",
        "Tanks",
        "Piping",
        "Pipeline",
        "Structurals",
        "Pumps",
        "Valves",
        "Compressors",
        "Skids",
        "System Auditor",
        "Remarks",
      ]);

      // ----------- Data Rows for Mechanical ----------
      data.forEach((row, i) => {
        wsData.push([
          i + 1,
          row.emp_name,
          row.location,
          row.experience,
          row.qualification,
          row.ndePlt,
          row.ndeRt,
          row.ndeUt,
          row.ndeMpt,
          row.ndeVt,
          row.ndeFet,
          row.bgas,
          row.api,
          row.welding,
          row.metalPlates,
          row.metalPipe,
          row.metalLinePipe,
          row.metalFlanges,
          row.metalFittings,
          row.metalFasteners,
          row.metalForging,
          row.metalCasting,
          row.metalRolling,
          row.dabMetalPressureVessel,
          row.dabMetalHeatExchangers,
          row.fabMetalColumns,
          row.fabMetalReactors,
          row.fabMetalTanks,
          row.fabMetalPiping,
          row.fabMetalPipeline,
          row.fabMetalStructurals,
          row.machinePumps,
          row.amchineValvs,
          row.machineCompressors,
          row.machineSkids,
          row.systemAuditor,
          row.remark,
        ]);
      });
    }

    const worksheet = XLSX.utils.aoa_to_sheet(wsData);

    // ----------- Merging logic ----------
    worksheet["!merges"] = [];

    if (searchBy === "Electrical") {
      worksheet["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } }, // Sr.No.
        { s: { r: 0, c: 1 }, e: { r: 2, c: 1 } }, // Name
        { s: { r: 0, c: 2 }, e: { r: 2, c: 2 } }, // Location
        { s: { r: 0, c: 3 }, e: { r: 2, c: 3 } }, // Experience
        { s: { r: 0, c: 4 }, e: { r: 2, c: 4 } }, // Basic Qualification
        { s: { r: 0, c: 5 }, e: { r: 0, c: 13 } }, // NABCB
        { s: { r: 1, c: 5 }, e: { r: 1, c: 13 } }, // Electrical Equipment
        { s: { r: 0, c: 14 }, e: { r: 2, c: 14 } }, // QMS Auditor
        { s: { r: 0, c: 15 }, e: { r: 2, c: 15 } }, // Remarks
      ];
    } else {
      // ----------- Merge for Mechanical ----------
      worksheet["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } },
        { s: { r: 0, c: 1 }, e: { r: 2, c: 1 } },
        { s: { r: 0, c: 2 }, e: { r: 2, c: 2 } },
        { s: { r: 0, c: 3 }, e: { r: 2, c: 3 } },
        { s: { r: 0, c: 4 }, e: { r: 2, c: 4 } },

        { s: { r: 0, c: 5 }, e: { r: 0, c: 10 } }, // NDE
        { s: { r: 1, c: 5 }, e: { r: 2, c: 5 } },
        { s: { r: 1, c: 6 }, e: { r: 2, c: 6 } },
        { s: { r: 1, c: 7 }, e: { r: 2, c: 7 } },
        { s: { r: 1, c: 8 }, e: { r: 2, c: 8 } },
        { s: { r: 1, c: 9 }, e: { r: 2, c: 9 } },
        { s: { r: 1, c: 10 }, e: { r: 2, c: 10 } },

        { s: { r: 0, c: 11 }, e: { r: 2, c: 11 } }, // BGAS
        { s: { r: 0, c: 12 }, e: { r: 2, c: 12 } }, // API
        { s: { r: 0, c: 13 }, e: { r: 2, c: 13 } }, // Welding

        { s: { r: 0, c: 14 }, e: { r: 0, c: 22 } }, // NABCB 17a
        { s: { r: 1, c: 14 }, e: { r: 1, c: 22 } }, // Basic Metals

        { s: { r: 0, c: 23 }, e: { r: 0, c: 30 } }, // NABCB 17b
        { s: { r: 1, c: 23 }, e: { r: 1, c: 30 } }, // Fabricated Metal Products

        { s: { r: 0, c: 31 }, e: { r: 0, c: 34 } }, // NABCB 18
        { s: { r: 1, c: 31 }, e: { r: 1, c: 34 } }, // Machinery & Equipment

        { s: { r: 0, c: 35 }, e: { r: 2, c: 35 } }, // QMS
        { s: { r: 0, c: 36 }, e: { r: 2, c: 36 } }, // Remarks
      ];
    }

    worksheet["!cols"] = Array(
      worksheet["!ref"].split(":")[1].charCodeAt(0) - 64
    ).fill({ wch: 20 });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Qualification");

    const buffer = XLSX.write(workbook, { type: "array", bookType: "xlsx" });
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `Qualification-${searchBy}.xlsx`);
  };

  return (
    <AddButton
      id="btn-add-outline"
      label="Export Excel"
      onClick={exportToExcel}
    />
  );
};
